import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { spacing } from '../constants/spacing';
import { typography } from '../constants/typography';
import { useAppColors } from '../context/PreferencesContext';
import { darkColors } from '../constants/colors';

type Props = {
  label: string;
};

export function StatusBadge({ label }: Props) {
  const palette = useAppColors();
  const isDark = palette.background === darkColors.background;
  const normalized = label.trim().toLowerCase();
  const tone =
    normalized === 'active'
      ? 'active'
      : normalized === 'inactive'
        ? 'inactive'
        : normalized === 'pending'
          ? 'pending'
          : 'neutral';

  const toneStyle =
    tone === 'active'
      ? {
          backgroundColor: isDark ? '#054F31' : '#E8F5E9',
        }
      : tone === 'inactive'
        ? {
            backgroundColor: isDark ? '#7A271A' : '#FFEBEE',
          }
        : tone === 'pending'
          ? {
              backgroundColor: isDark ? '#5C4813' : '#FFF8E1',
            }
          : {
              backgroundColor: palette.border,
            };

  return (
    <View
      accessibilityRole="text"
      accessibilityLabel={`Status ${label}`}
      style={[styles.badge, toneStyle]}
    >
      <Text style={[styles.text, { color: palette.textPrimary }]}>{label}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  badge: {
    alignSelf: 'flex-start',
    borderRadius: 6,
    paddingHorizontal: spacing.sm,
    paddingVertical: spacing.xs,
  },
  text: {
    ...typography.caption,
    fontWeight: '600',
  },
});
